import { render, staticRenderFns } from "./giftDraw.vue?vue&type=template&id=4dd8bd87&scoped=true"
import script from "./giftDraw.vue?vue&type=script&lang=js"
export * from "./giftDraw.vue?vue&type=script&lang=js"
import style0 from "./giftDraw.vue?vue&type=style&index=0&id=4dd8bd87&prod&lang=scss"
import style1 from "./giftDraw.vue?vue&type=style&index=1&id=4dd8bd87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd8bd87",
  null
  
)

export default component.exports